module.exports = __webpack_public_path__ + "img/icons_13.5379d054.svg";